import { TutorialConfig } from "../features/tutorial/TutorialConfig";
import { tutorialStepMap } from "../features/tutorial/tutorialStepMap";
import { selectPlayerInfo } from "./selectPlayerInfo";
// We will need this selector to group other selector that we will need during implementing real tutorial
export var selectTutorial = function (state) {
    return state.tutorial.tutorialStep;
};
export var selectTutorialConfig = function (state, tutorialStep) {
    return TutorialConfig[tutorialStep];
};
export var selectActiveTutorialConfig = function (state) {
    var tutorialStep = state.tutorial.tutorialStep;
    if (tutorialStep === undefined) {
        return undefined;
    }
    return TutorialConfig[tutorialStep];
};
export var selectActiveTutorialComponent = function (state) {
    var tutorialStep = state.tutorial.tutorialStep;
    if (tutorialStep === undefined) {
        return undefined;
    }
    if (tutorialStepMap.has(tutorialStep)) {
        return tutorialStepMap.get(tutorialStep);
    }
    return undefined;
};
export var selectIsTutorialBuilding = function (state, building) {
    var activeTutorialConfig = selectActiveTutorialConfig(state);
    if (activeTutorialConfig && activeTutorialConfig.buildingId && building != undefined) {
        return building.balancing.id === activeTutorialConfig.buildingId;
    }
    return true;
};
export var selectIsTutorialActive = function (state) {
    var level = selectPlayerInfo(state).level;
    return state.tutorial.tutorialStep !== undefined || level === 1;
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectTutorial.ts
// module id = 65
// module chunks = 3